import React from 'react';
import { SelectValueViewer } from 'components';
import { getObjectValue } from 'utilities';
import getOptionsAccordingApproach from './getOptionsAccordingApproach';
import { MultipleTypeApproachProps } from './types';

const MultipleTypeApproachValueViewer = (props: MultipleTypeApproachProps) => {
  const { cell } = getObjectValue(props);
  const options = getOptionsAccordingApproach(cell);

  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-ignore: ScalarSpreadsheet is not typed */
  return <SelectValueViewer options={options} {...props} />;
};

export default MultipleTypeApproachValueViewer;
